import { render, staticRenderFns } from "./CaseTypesModal.vue?vue&type=template&id=148d02e8&"
import script from "./CaseTypesModal.vue?vue&type=script&lang=js&"
export * from "./CaseTypesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports